import repository from "@/plugins/axios/secureClient";
import { DownloadFile } from "@/utils/LoadFile.js";

const resource = "/presentation-contacts";

export default {
  getList(params) {
    return repository.get(`${resource}/`, { params });
  },
  export(params, onDownloadProgress) {
    return DownloadFile(`${resource}/export`, "GET", {
      params,
      onDownloadProgress
    });
  }
};
